var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.9,
    height: 35.22,
    viewBox: "0 0 28.9 35.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.489,
    y1: 0.284,
    x2: 0.551,
    y2: 1.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.62,
    y1: 0.732,
    x2: 0.359,
    y2: -0.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.198,
    y1: 0.169,
    x2: 1.196,
    y2: 1.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.387,
    y1: 0.329,
    x2: 0.018,
    y2: 0.016,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.199,
    y1: 0.546,
    x2: 1.196,
    y2: 1.544,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.787,
    y1: 0.77,
    x2: 0.411,
    y2: 0.402,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.378,
    y1: 0.313,
    x2: 0.673,
    y2: 0.764,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "your-location",
    transform: "translate(-45.757)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 13.184,
    cy: 2.835,
    rx: 13.184,
    ry: 2.835,
    transform: "translate(47.023 29.55)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4267",
    "data-name": "Path 4267",
    d: "M221.027,430.731c0-1.566-5.9-2.835-13.184-2.835-1.211,0-2.384.035-3.5.1l2.468,3.631a1.252,1.252,0,0,0,.237.261l1.671,1.671C215.593,433.462,221.027,432.233,221.027,430.731Z",
    transform: "translate(-147.636 -398.346)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4268",
    "data-name": "Path 4268",
    d: "M74.658,14.45a14.45,14.45,0,1,0-20.2,13.261,4.975,4.975,0,0,1,2.132,1.768l2.585,3.8a1.246,1.246,0,0,0,2.061,0l2.585-3.8a4.955,4.955,0,0,1,2.124-1.764,14.453,14.453,0,0,0,8.71-13.264Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    "data-name": "Path 4269",
    d: "M69.915,42.814a.521.521,0,0,1-.435-.23l-2.585-3.8a5.685,5.685,0,0,0-2.441-2.023,13.728,13.728,0,0,1,5.462-26.33h0A13.732,13.732,0,0,1,75.369,36.76a5.666,5.666,0,0,0-2.434,2.02l-2.585,3.8a.521.521,0,0,1-.435.23Z",
    transform: "translate(-9.707 -9.707)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 9.083,
    cy: 9.083,
    r: 9.083,
    transform: "translate(51.124 5.367)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    "data-name": "Path 4270",
    d: "M169.8,113.646l-8.63-8.63a7.358,7.358,0,1,0-10.4,10.4l9.095,9.095a4.93,4.93,0,0,1,1.677-1.2A14.483,14.483,0,0,0,169.8,113.646Z",
    transform: "translate(-95.599 -95.598)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 7.358,
    cy: 7.358,
    r: 7.358,
    transform: "translate(52.849 7.092)",
    fill: "url(#linear-gradient-7)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.c6a0a0fafeba5e83683e50f28ce26ef1.svg";
export { ForwardRef as ReactComponent };